import { useFeatureFlag } from 'shared/lib/hooks/useFeatureFlag';

interface UseReportVisibleArgs {
    flagKey: string;
    canSee: boolean | undefined;
    isReOpsUser: boolean;
}

export const useReportVisible = ({
    flagKey,
    canSee,
    isReOpsUser,
}: UseReportVisibleArgs): boolean | undefined => {
    const flagEnabled = useFeatureFlag(flagKey);

    if (flagEnabled === null) {
        return undefined;
    }

    if (!canSee) {
        return false;
    }

    return flagEnabled === true || isReOpsUser;
};
